

import { Card } from "react-bootstrap"
import QuestionTypeSelector from "./question-type-selector"
import TrueFalseQuestion from "./question-types/true-false-question"
import MultipleChoiceQuestion from "./question-types/multiple-choice-question"
import FillInBlankQuestion from "./question-types/fill-in-blank-question"
import ShortAnswerQuestion from "./question-types/short-answer-question"
import LongAnswerQuestion from "./question-types/long-answer-question"
import MatchingQuestion from "./question-types/matching-question"
import { X } from "lucide-react"

export default function QuestionCard({ question, questionNumber, onUpdate ,hasValidationError ,handleRemove,quizType }) {
  const renderQuestionContent = () => {
    switch (question.type) {
      
      case "true_false":
        return <TrueFalseQuestion question={question} onUpdate={onUpdate} showValidation={hasValidationError} />
      case "multiple_choice":
        return <MultipleChoiceQuestion question={question} onUpdate={onUpdate} showValidation={hasValidationError} />
      case "fill_blank":
        return <FillInBlankQuestion question={question} onUpdate={onUpdate} showValidation={hasValidationError} />
      case "short_answer":
        return <ShortAnswerQuestion question={question} onUpdate={onUpdate} showValidation={hasValidationError} />
      case "long_answer":
        return <LongAnswerQuestion question={question} onUpdate={onUpdate} showValidation={hasValidationError} />
      case "matching":
          return <MatchingQuestion question={question} onUpdate={onUpdate} showValidation={hasValidationError} />
      default:
        return null
    }
  }

  return (
    <Card className="mb-2" style={{ backgroundColor: "#f8f9fa",  border: hasValidationError ? "1px solid #dc3545" : "1px solid #dee2e6" }}>
      <Card.Body className="px-4">
        <div className="d-flex justify-content-between">
        <h5 className="mb-3" style={{ fontSize: "16px", fontWeight: "600" }}>
          Question {questionNumber} 
        </h5>
        <span onClick={() =>handleRemove(question.id)} style={{cursor:"pointer"}}>
        <X size={20} />
        </span>
       
        </div>
        {hasValidationError && (
            <span className="text-danger ms-2" style={{ fontSize: "14px" }}>
              (Has errors - check above)
            </span>
          )}

        <QuestionTypeSelector selectedType={question.type} onTypeChange={(type) => onUpdate({ type })} quizType={quizType} />

        {renderQuestionContent()}
      </Card.Body>
    </Card>
  )
}
